require('../../common/rule/ruleMediator.js');
require('../../common/rule/ruleModel.js');
require('../../common/rule/ruleRepository.js');
require('../../common/rule/ruleUtil.js');
require('../../common/rule/ruleAction/ruleActionComponent.js');
require('../../common/rule/ruleAction/parameterizedAction/parameterizedActionComponent.js');
require('../../common/rule/ruleActionGroup/ruleActionGroupComponent.js');
require('../../common/rule/ruleCondition/ruleConditionComponent.js');
require('../../common/rule/ruleConditionGroup/ruleConditionGroupComponent.js');
require('../../common/rule/ruleHeader/ruleHeaderComponent.js');

require('./content/rule/formRules.i18n.json');
require('./content/rule/formRules.tpl.html');
require('./content/rule/formRulesController.js');
require('./content/rule/fieldRuleBuilder/fieldRuleActionComponent.js');
require('./content/rule/fieldRuleBuilder/fieldRuleBuilderComponent.js');
require('./content/rule/formRuleBuilder/formRuleBuilderComponent.js');
require('./content/rule/leftNav/ruleBuilderLeftNavComponent.js');
require('./content/rule/reviewRule/validateRuleModal.tpl.html');
require('./content/rule/reviewRule/validateRuleModalController.js');
require('./content/preview/formPreview.tpl.html');
require('./content/form/formBuilderController.js');

/*@ngInject*/
const FormEditorController = function () {


};

angular.module('ums.configuration').controller('formEditorController', FormEditorController);
